import { KeyConstant } from "@/const";
import { StorageUtils } from "@/utils";
import { ResponseLoginType } from "./auth.service";
import { isElectron } from "@/utils/common.utils";

type SdkLoginPayload = ResponseLoginType & {
  email: string;
};

const SdkLib: any = (window as any).e2eSdk;

export const loginSdk = async (loginData: SdkLoginPayload) => {
  if (isElectron()) {
    const token = await SdkLib.login(loginData.thirdPartyToken, loginData.userUid);
    StorageUtils.setItem(KeyConstant.KEY_TOKEN_SDK, token);
  }
  StorageUtils.setItem(KeyConstant.KEY_TOKEN, loginData.accessToken);
  StorageUtils.setItem(KeyConstant.KEY_UID, loginData.userUid);
  StorageUtils.setItem(KeyConstant.KEY_NAME, loginData.name);
  StorageUtils.setItem(KeyConstant.KEY_ROLE, loginData.role.toString());
  StorageUtils.setItem(KeyConstant.KEY_AVATAR, loginData.avatar);
};

export const encryptFile = async (bufferFile: ArrayBuffer, userUids: string[]) => {
  const sdkToken = StorageUtils.getItem<string>(KeyConstant.KEY_TOKEN_SDK);
  const response = await SdkLib.encryptFile(sdkToken, userUids, bufferFile);
  return response;
};

export const decryptFile = async (bufferFile: ArrayBuffer) => {
  const sdkToken = StorageUtils.getItem<string>(KeyConstant.KEY_TOKEN_SDK);
  const response = await SdkLib.decryptFile(sdkToken, bufferFile);
  return response;
};
